<template>
    <v-container>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate
                                 size="64"></v-progress-circular>
        </v-overlay>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title class="primary">
                        <v-toolbar-title style="color: white;">
                            Procesar Tramite Pago de Reporte
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-icon color="white">mdi-file-document-multiple-outline</v-icon>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" md="6" offset-md="3">
                                <v-list v-if="datosReporte[0]" style="color: black !important;">
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title style="color: black !important;">Tipo:</v-list-item-title>
                                            <v-list-item-subtitle style="color: black;"><h6>Validación de Reporte para pago</h6></v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title style="color: black !important;">Reporte:</v-list-item-title>
                                            <v-list-item-subtitle style="color: black;"><h6>{{reporte.nrreporte}}-{{reporte.svindice}}</h6></v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title style="color: black !important;">Asistencia:</v-list-item-title>
                                            <v-list-item-subtitle style="color: black;"><h6>{{datosReporte[0].asistencia}}</h6></v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title style="color: black !important;">Abogado:</v-list-item-title>
                                            <v-list-item-subtitle style="color: black;"><h6>{{datosReporte[0].prclave}} - {{datosReporte[0].prnombre}}</h6></v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title style="color: black !important;">Fecha Conclusión:</v-list-item-title>
                                            <v-list-item-subtitle style="color: black;"><h6>{{datosReporte[0].svfhconclusion}}</h6></v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title style="color: black !important;">Aseguradora:</v-list-item-title>
                                            <v-list-item-subtitle style="color: black;"><h6>{{datosReporte[0].clnombre}}</h6></v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>Fecha:</v-list-item-title>
                                            <v-menu ref="menu1" style="z-index: 200; position: absolute;"
                                                    v-model="menu1"
                                                    :close-on-content-click="false"
                                                    transition="scale-transition"
                                                    offset-y
                                                    max-width="290px"
                                                    min-width="auto">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field v-model="dateFormatted"
                                                                  outlined
                                                                  readonly
                                                                  v-bind="attrs"
                                                                  @blur="date = parseDate(dateFormatted)"
                                                                  v-on="on"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="date"
                                                               locale="es-mx"
                                                               :max="maxfecha"
                                                               :min="mindate"
                                                               @input="menu1 = false"></v-date-picker>
                                            </v-menu>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>¿Expediente se paga?:</v-list-item-title>
                                            <v-form ref="frmrespuesta" v-model="valid" lazy-validation>
                                                <v-radio-group v-model="rbrespuesta" row :rules="[v => !!v || 'Opción requerida']" @change="Valida()">
                                                    <v-radio label="Si" style="color: black; text-align: center;"
                                                             value="1"></v-radio>
                                                    <v-radio label="No" style="color: black !important; text-align: center;"
                                                             value="2"></v-radio>
                                                </v-radio-group>
                                            </v-form>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-col>
                            <v-col cols="12" md="6" offset-md="3" v-if="rbrespuesta == 1">

                                <vs-list>
                                    <label class="typo__label" style="color: black; text-align: center;">Concepto de pago:</label>
                                    <div>
                                        <multiselect placeholder="Seleccione un valor" :options="conceptopago" v-model="concepto"
                                                     label="cpdesc" track-by="cpclave"
                                                     deselect-label="No se puede remover el valor seleccionado"
                                                     :allow-empty="false"
                                                     selected-label="Seleccionado" select-label="Seleccionar valor" :class="colors" @input="addTag2(2)">
                                        </multiselect>
                                        <span style="color: red;" v-show="validaconcepto">Selección requerida</span>
                                    </div>
                                </vs-list>
                            </v-col>
                            <v-col cols="12" md="6" offset-md="3" v-if="rbrespuesta == 2">
                                <vs-list class="mb-10">
                                    <label class="typo__label" style="color: black; text-align: center;">Motivo del rechazo:</label>
                                    <div>
                                        <multiselect placeholder="Seleccione un valor" :options="conceptopago" v-model="motivo"
                                                     label="cpdesc" track-by="cpclave"
                                                     deselect-label="No se puede remover el valor seleccionado"
                                                     :allow-empty="false"
                                                     selected-label="Seleccionado" select-label="Seleccionar valor" :class="colors" @input="addTag()">
                                        </multiselect>
                                        <span style="color: red;" v-if="validaMulti">Selección requerida</span>
                                    </div>
                                </vs-list>
                            </v-col>
                            <v-col cols="12" md="4" v-if="rbrespuesta == 1" offset-md="3">
                                <vs-list v-if="rbrespuesta == 1">
                                    <label class="typo__label" style="color: black; text-align: center;">Nivel 1:</label>
                                    <multiselect placeholder="Seleccione un valor" :options="nivel1"
                                                 label="gtnivel1" track-by="gtcv1" v-model="mnivel1"
                                                 deselect-label="No se puede remover el valor seleccionado"
                                                 :allow-empty="false"
                                                 selected-label="Seleccionado" select-label="Seleccionar valor" :class="colors" @input="addnivel1()">
                                    </multiselect>
                                </vs-list>
                                <vs-list>
                                    <label class="typo__label" style="color: black; text-align: center;">Nivel 2:</label>
                                    <multiselect placeholder="Seleccione un valor" :options="nivel2"
                                                 label="gtnivel2" track-by="gtcv2" v-model="mnivel2"
                                                 deselect-label="No se puede remover el valor seleccionado"
                                                 :allow-empty="false"
                                                 selected-label="Seleccionado" select-label="Seleccionar valor" :class="colors" @input="addnivel2()">
                                    </multiselect>

                                </vs-list>
                                <vs-list>
                                    <label class="typo__label" style="color: black; text-align: center;">Nivel 3:</label>
                                    <multiselect placeholder="Seleccione un valor" :options="nivel3" v-model="mnivel3"
                                                 label="gtnivel3" track-by="gtcv3"
                                                 deselect-label="No se puede remover el valor seleccionado"
                                                 :allow-empty="false"
                                                 selected-label="Seleccionado" select-label="Seleccionar valor" :class="colors" @input="addnivel3()">
                                    </multiselect>
                                </vs-list>
                                <vs-list>
                                    <label class="typo__label" style="color: black; text-align: center;">Nivel 4:</label>
                                    <multiselect placeholder="Seleccione un valor" :options="nivel4" v-model="mnivel4"
                                                 label="gtnivel4" track-by="gtcv4"
                                                 :allow-empty="false"
                                                 deselect-label="No se puede remover el valor seleccionado"
                                                 selected-label="Seleccionado" select-label="Seleccionar valor" :class="colors" @input="addnivel4()">
                                    </multiselect>
                                </vs-list>
                                <vs-list>
                                    <label class="typo__label" style="color: black; text-align: center;">Nivel 5:</label>
                                    <multiselect placeholder="Seleccione un valor" :options="nivel5" v-model="mnivel5"
                                                 label="gtnivel5" track-by="gtcv5"
                                                 :allow-empty="false"
                                                 deselect-label="No se puede remover el valor seleccionado"
                                                 selected-label="Seleccionado" select-label="Seleccionar valor" :class="colors">
                                    </multiselect>
                                </vs-list>
                                <span id="valnivel" style="display: none">Selección requrida</span>
                            </v-col>
                            <v-col cols="12" md="2" v-if="rbrespuesta == 1">
                                <v-form ref="frmsi" v-model="valid" lazy-validation>
                                    <vs-list v-if="rbrespuesta == 1">
                                        <label class="typo__label" style="color: black; text-align: center;">
                                            Monto:
                                        </label>
                                        <v-text-field outlined
                                                      :rules="reglamonto"
                                                      @keypress="filter($event)"
                                                      v-model="monto"
                                                      :disabled="valmonto"
                                                      :required="requiere"
                                                      :error-messages="errormonto">
                                        </v-text-field>
                                    </vs-list>
                                </v-form>
                                <v-row justify="center" class="mb-8">
                                    <v-btn class="ma-2"
                                           @click="Agregar()"
                                           :disabled="habilitar"
                                           color="primary">
                                        Agregar
                                    </v-btn>
                                </v-row>
                            </v-col>
                            <v-col cols="12" md="6" offset-md="3" v-if="rbrespuesta == 1">
                                <v-data-table :headers="header"
                                              hide-default-footer
                                              no-data-text="No hay datos disponibles"
                                              :items="partidas">
                                    <template v-slot:[`item.actions`]="{ item }">
                                        <v-btn color="error"
                                               v-on:click="Eliminar(item);"
                                               small
                                               fab
                                               dark>
                                            <v-icon>
                                                mdi-trash-can-outline
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <template v-slot:body.append>
                                        <tr>
                                            <td></td>
                                            <td>
                                                {{total}}
                                            </td>
                                            <td></td>
                                        </tr>
                                    </template>
                                </v-data-table>
                                <span style="color: red;">{{errorpartida}}</span>
                            </v-col>
                            <v-col cols="12" md="6" offset-md="3">
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title>Observación:</v-list-item-title>
                                        <v-form ref="frm" v-model="valids" lazy-validation>
                                            <v-textarea outlined
                                                        v-model="obs"
                                                        :rules="rulestextarea"
                                                        :counter="500"
                                                        name="txtobs"
                                                        required>
                                            </v-textarea>
                                        </v-form>
                                    </v-list-item-content>
                                </v-list-item>
                                <!--</v-list>-->
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" class="text-center">
                                <v-btn class="ma-2"
                                       @click="Guardar()"
                                       color="primary">
                                    Guardar
                                    <template v-slot:loader>
                                        <span>Loading...</span>
                                    </template>
                                </v-btn>
                                <v-btn class="ma-2" @click="Limpiar()">
                                    Limpiar
                                </v-btn>
                                <v-btn class="ma-2" @click="Regresar()" color="error">
                                    Regresar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    import { mapActions, mapState } from 'vuex';
    import moment from "moment";
    import servicio from '@/services/TramitePago/TramitePago.Service.js';
    import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
    import List from '../../documentos/list.vue';

    export default {
        title() {
            return this.$route.meta.title
        },
        data: vm => ({
            valid: true,
            valids: true,
            valmonto: false,
            maxfecha: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            dateFormatted: vm.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
            menu1: false,
            colors: '',
            obs: '',
            correcciones: '',
            monto: '',
            estatus: ["Falta Documentación", "Liberación Vehículo"],
            rbrespuesta: 0,
            reporte: [],
            selected: '',
            validaMulti: false,
            validaconcepto: false,
            datosReporte: [],
            rulestextarea: [
                v => !!v || 'Campo requerido',
                v => {
                    if (v == null) {
                        return true
                    }
                    else {
                        if (v.length < 12) {
                            return 'Mínimo 12 Carácteres'
                        }
                        else if (v.length > 500) {
                            return 'Máximo 500 Carácteres'
                        }
                        else
                            return true
                    }
                },
            ],
            reglamonto: [
                v => !!v || 'Campo requerido',
                v => {
                    if (v < 500) {
                        return 'Monto invalido'
                    }
                    else if (v > 2000000) {
                        return 'Monto invalido'
                    }
                    else
                        return true
                }
            ],
            habilitar: false,
            requiere: false,
            conceptopago: [],
            motivocancelar: [],
            concepto: '',
            motivo: '',
            npid: 0,
            mindate: '',
            cc: [],
            mcc: [],
            nivel1: [],
            mnivel1: [],
            nivel2: [],
            mnivel2: null,
            nivel3: [],
            mnivel3: null,
            nivel4: [],
            mnivel4: null,
            nivel5: [],
            mnivel5: null,
            header: [
                { text: 'Concepto', value: 'partida', class: 'text title' },
                { text: 'Monto', value: 'monto', class: 'text title' },
                { text: 'Acción', value: 'actions', class: 'text title' },
            ],
            partidas: [],
            total: '',
            errorpartida: '',
            errormonto: '',
            overlay: false,
            clclave: '',
        }),
        computed: {
            ...mapState([
                "domain",
                "informationPage",
                "paginacion",
                "permission",
                "user"
            ]),
            computedDateFormatted() {
                return this.formatDate(this.date)
            },
        },
        watch: {
            date(val) {
                this.dateFormatted = this.formatDate(this.date)
            },
            
        },
        methods: {
            addTag() {
                if (this.motivo !== "" && this.motivo !== null) {
                    this.colors = '';
                    this.validaMulti = false;
                }
            },
            addTag2(valor) {
                switch (valor) {
                    case 1:
                        if (this.mcc !== "" && this.mcc !== null) {
                            this.colors = '';
                        }
                        break;
                    case 2:
                        if (this.concepto !== "" && this.concepto !== null) {
                            this.colors = '';
                        }
                        break;
                }
            },
            addnivel1() {
                this.valmonto = false;
                this.mnivel2 = [];
                this.mnivel3 = [];
                this.mnivel4 = [];
                this.mnivel5 = [];
                this.obtenerNivel2();
            },
            addnivel2() {
                this.valmonto = false;
                this.mnivel3 = [];
                this.mnivel4 = [];
                this.mnivel5 = [];
                this.nivel3 = [];
                this.nivel4 = [];
                this.nivel5 = [];
                this.obtenerNivel3();
            },
            addnivel3() {
                this.nivel4 = [];
                this.mnivel4 = [];
                this.nivel5 = [];
                this.obtenerNivel4();
            },
            addnivel4() {
                this.nivel5 = [];
                this.mnivel5 = [];
                this.obtenerNivel5();
            },
            filter: function (evt) {
                evt = (evt) ? evt : window.event;
                let expect = evt.target.value.toString() + evt.key.toString();

                if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            formatDate(date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },
            parseDate(date) {
                if (!date) return null

                const [day, month, year] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },
            Valida() {
                this.selected = '';
                this.$refs.frm.reset();
                this.validaMulti = false;
                this.validaconcepto = false;
                this.motivo = '';
                this.concepto = '';
                if (this.rbrespuesta == 1) {
                    this.ConceptoPago('S');
                }
                else {
                    this.ConceptoPago('N');
                }
            },
            Limpiar() {
                this.selected = '';
                if (this.rbrespuesta == 1)
                    this.$refs.frmsi.reset();
                this.rbrespuesta = 0;
                this.date = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
                this.obs = '';
                this.concepto = '';
                this.motivo = '';
                this.mnivel1 = null;
                this.mnivel2 = null;
                this.mnivel3 = null;
                this.mnivel4 = null;
                this.mnivel5 = null;
                this.partidas = [];
                this.total = '';
                this.habilitar = false;
            },
            Regresar() {
                this.$router.push({ name: 'ReportesPendientePagar' });
            },
            Agregar() {
                let validar = true;
                
                if (this.mnivel1 == null || this.mnivel2 == null || this.mnivel3 == null || this.mnivel4 == null || this.mnivel5 == null) {
                    document.getElementById("valnivel").setAttribute("style", "display: inherit; color: red");
                    this.colors = 'border: 1px solid red;';
                    validar = false;
                }
                if (!this.$refs.frmsi.validate()) {
                    validar = false;
                }                
                if (validar) {
                    let datos = new Object();
                    if (this.mnivel2.gtcv2 != 0 && this.mnivel3.gtcv3 != 0) {
                        if (this.mnivel4.gtcv4 != 0) {
                            if (this.mnivel5 != 0) {
                                datos.partida = this.mnivel5.gtnivel5;
                                datos.monto = MetodosGenerales.regresarValorMoneda(this.monto, '$');
                            }
                            else {
                                datos.partida = this.mnivel4.gtnivel4;
                                datos.monto = MetodosGenerales.regresarValorMoneda(this.monto, '$');
                            }
                        }
                        else {
                            datos.partida = this.mnivel3.gtnivel3;
                            datos.monto = MetodosGenerales.regresarValorMoneda(this.monto, '$');
                        }
                    }
                    else {
                        datos.partida = this.mnivel2.gtnivel2;
                        datos.monto = MetodosGenerales.regresarValorMoneda(this.monto, '$');
                    }
                    let index = 0;
                    
                    if (this.partidas.length == 0) {
                        datos.gtid = this.mnivel5.gtid;
                        this.partidas.push(datos);
                        this.total = 0;
                        for (let x in this.partidas) {
                            this.total += parseFloat(this.partidas[x].monto.replace(/([^0-9\.\-])/g, ''));//Ahora que es un objeto javascript, tiene propiedades
                        }
                        this.total = MetodosGenerales.regresarValorMoneda(this.total, '$');
                        this.errorpartida = '';
                        this.valmonto = true;
                        this.habilitar = true;
                    }
                    else {
                        this.$swal({
                            position: "center",
                            icon: "error",
                            title: "Error",
                            text: "No se puede agregar mas de una partida",
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            showConfirmButton: true,
                            confirmButtonText: "Ok!",
                        });
                        
                    }
                    this.mnivel2 = null;
                    this.mnivel3 = null;
                    this.mnivel4 = null;
                    this.mnivel5 = null;
                    this.monto = '';
                    this.$refs.frmsi.reset();
                }
                
            },
            Guardar() {
                

                if (this.$refs.frmrespuesta.validate() ) {
                    if (this.obs != null) {
                        this.obs = this.obs.replace(/\s*$/, "");
                        this.obs = this.obs.trim();
                    }

                    let formdata = new FormData();
                    formdata.append("reporte", this.reporte.nrreporte);
                    formdata.append("indice", this.reporte.svindice);
                    formdata.append("fecha", this.date);
                    formdata.append("respuesta", this.rbrespuesta);
                    formdata.append("obs", this.obs);
                    formdata.append("abogado", this.datosReporte[0].prnombre);
                    if (this.rbrespuesta == 1) {
                        if (this.partidas.length == 0)
                            this.errorpartida = 'Falta agregar una partida';

                        if (this.concepto === "" || this.concepto === null) {
                            this.colors = 'border: 1px solid red;';
                            this.validaconcepto = true;
                        }
                        else
                            this.validaconcepto = false;
                        formdata.append("total", parseFloat(this.total.replace(/([^0-9\.\-])/g, '')));
                        formdata.append("concepto", this.concepto.cpclave);
                        
                        if (this.$refs.frm.validate() &&  this.obs.length >= 12 && this.validaconcepto == false && this.partidas.length > 0) {
                            for (let x in this.partidas) {
                                this.partidas[x].monto = parseFloat(this.partidas[x].monto.replace(/([^0-9\.\-])/g, ''));//Ahora que es un objeto javascript, tiene propiedades
                            }
                            formdata.append("partidas", JSON.stringify(this.partidas));
                            this.$swal({
                                title: "Guardando, espere un momento...",
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                            });
                            this.$swal.showLoading();
                            servicio.ProcesarPago(this, formdata).then(data => {
                                this.valmonto = true;
                                if (data[0].success == "True") {
                                    this.$swal({
                                        position: "center",
                                        icon: "success",
                                        title: "Éxito",
                                        text: "El reporte fue aceptado para su pago",
                                        allowOutsideClick: false,
                                        allowEscapeKey: false,
                                        showConfirmButton: true,
                                        timer: 4000,
                                        confirmButtonText: "Ok!",
                                    }).then(() => {
                                        this.$router.push({ name: `ReportesPendientePagar` });
                                    });
                                }
                                else {
                                    this.$swal({
                                        position: "center",
                                        icon: "error",
                                        title: "Error",
                                        text: "No se puede guardar, por favor intente de nuevo más tarde, si el problema persiste, pónganse en contacto con el equipo de asistencia técnica",
                                        allowOutsideClick: false,
                                        allowEscapeKey: false,
                                        showConfirmButton: true,
                                        confirmButtonText: "Ok!",
                                    });
                                }
                            })
                        }
                    }
                    else {
                        if (this.motivo === "" || this.motivo === null) {
                            this.colors = 'border: 1px solid red;';
                            this.validaMulti = true;
                        }
                        else
                            this.validaMulti = false;
                        formdata.append("motivo", this.motivo.cpclave);
                        formdata.append("clclave", this.clclave);

                        if (this.$refs.frm.validate() && this.obs.length >= 12 && this.validaMulti == false) {
                            this.$swal({
                                title: "Guardando, espere un momento...",
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                            });
                            this.$swal.showLoading();
                            servicio.RechazarPago(this, formdata).then(data => {
                                if (data[0].success == "true") {
                                    this.$swal({
                                        position: "center",
                                        icon: "success",
                                        title: "Éxito",
                                        text: "El reporte fue rechazado",
                                        allowOutsideClick: false,
                                        allowEscapeKey: false,
                                        showConfirmButton: true,
                                        timer: 4000,
                                        confirmButtonText: "Ok!",
                                    }).then(() => {
                                        this.$router.push({ name: `ReportesPendientePagar` });
                                    });
                                }
                                else {
                                    this.$swal({
                                        position: "center",
                                        icon: "error",
                                        title: "Error",
                                        text: "No se puede guardar, por favor intente de nuevo más tarde, si el problema persiste, pónganse en contacto con el equipo de asistencia técnica",
                                        allowOutsideClick: false,
                                        allowEscapeKey: false,
                                        showConfirmButton: true,
                                        confirmButtonText: "Ok!",
                                    });
                                }
                            })
                        }
                    }
                }
                
            },
            Eliminar(items) {
                this.partidas = this.partidas.filter((item) => item.id !== items.id);
                this.valmonto = false;
                this.total = '';
                this.habilitar = false;
            },
            async ObtenerDatosReporte() {
                let formdata = new FormData();
                formdata.append("reporte", this.reporte.nrreporte);
                formdata.append("indice", this.reporte.svindice);
                await servicio.ObtenerDatosReporte(this, formdata).then(data => {
                    this.datosReporte = data;
                    this.npid = data[0].npid;
                    this.clclave = data[0].clclave;
                    this.overlay = false;
                });
            },
            ConceptoPago(res) {
                let formdata = new FormData();
                formdata.append("iaclave", this.reporte.aiclave);
                formdata.append("respuesta", res);
                servicio.ConceptoPago(this, formdata).then(data => {
                    this.conceptopago = data;
                });
            },
            MotivoCancelar() {
                servicio.MotivoCancelar(this).then(data => {
                    this.motivocancelar = data;
                });
            },
            obtenerfecha() {
                let formdata = new FormData();
                formdata.append("npid", this.npid);
                servicio.ObtenerFecha(this, formdata).then(data => {
                    this.mindate = this.parseDate(data[0].npfhenvio);
                });
            },
            ObtenerCentroCosto() {
                servicio.CentroCosto(this).then(data => {
                    this.cc = data;
                });
            },
            obtenerNivel1() {
                servicio.ObtenerNivel1(this).then(data => {
                    this.nivel1 = data;
                });
            },
            obtenerNivel2() {
                if (this.mnivel1 != null) {
                    let formdata = new FormData();
                    formdata.append("nivel1", this.mnivel1.gtcv1);
                    servicio.ObtenerNivel2(this, formdata).then(data => {
                        this.nivel2 = data;
                    });
                }
                else {
                    this.nivel2 = [];
                    this.nivel3 = [];
                    this.nivel4 = [];
                    this.nivel5 = [];
                }
            },
            obtenerNivel3() {
                if (this.mnivel2 != null) {
                    let formdata = new FormData();
                    formdata.append("nivel1", this.mnivel1.gtcv1);
                    formdata.append("nivel2", this.mnivel2.gtcv2);
                    servicio.ObtenerNivel3(this, formdata).then(data => {
                        this.nivel3 = data;
                        if (data.length == 1) {
                            this.mnivel3 = data[0];
                            this.obtenerNivel4();
                        }
                    });
                }
                else {
                    this.nivel3 = [];
                    this.nivel4 = [];
                    this.nivel5 = [];
                }
            },
            obtenerNivel4() {
                if (this.mnivel3 != null) {
                    let formdata = new FormData();
                    formdata.append("nivel1", this.mnivel1.gtcv1);
                    formdata.append("nivel2", this.mnivel2.gtcv2);
                    formdata.append("nivel3", this.mnivel3.gtcv3);
                    servicio.ObtenerNivel4(this, formdata).then(data => {
                        this.nivel4 = data;
                        if (data.length == 1) {
                            this.mnivel4 = data[0];
                            this.obtenerNivel5();
                        }
                    });
                }
                else {
                    this.nivel4 = [];
                    this.nivel5 = [];
                }
            },
            obtenerNivel5() {
                if (this.mnivel4 != null) {
                    let formdata = new FormData();
                    formdata.append("nivel1", this.mnivel1.gtcv1);
                    formdata.append("nivel2", this.mnivel2.gtcv2);
                    formdata.append("nivel3", this.mnivel3.gtcv3);
                    formdata.append("nivel4", this.mnivel4.gtcv4);
                    servicio.ObtenerNivel5(this, formdata).then(data => {
                        this.nivel5 = data;
                        if (data.length == 1) {
                            this.mnivel5 = data[0];
                        }
                        if (this.mnivel1 != null && this.mnivel2 != null && this.mnivel3 != null && this.mnivel4 != null && this.mnivel5 != null) {
                            this.colors = '';
                            document.getElementById("valnivel").setAttribute("style", "display: none");
                        }
                    });
                }
                else {
                    this.nivel5 = [];
                }
            },
        },
        async mounted() {
            this.overlay = true;
            this.reporte = await MetodosGenerales.obtenerSessionReporte('reporte');

            await this.ObtenerDatosReporte();
            this.MotivoCancelar();
            this.obtenerfecha();
            this.obtenerNivel1();
            this.ObtenerCentroCosto();
            this.mnivel1 = {
                gtcv1: "03",
                gtnivel1: "Operativos"
            };
            this.addnivel1();
        }
    }
</script>
<style>
    .multiselect--active {
        z-index: 9999 !important;
    }

    .border-error {
        border-color: red;
    }
</style>